import React from "react";
import { APP_NAME, PUBLIC_PREFIX_PATH } from "configs/AppConfig";

/**
 * Logo do projeto (mesmos arquivos de `Logo.js`).
 * `placement="header"`: faixa da barra superior (largura alinhada ao menu lateral).
 */
const SidebarLogo = ({ collapsed, placement = "header", logoType }) => {
	const src =
		logoType === "light"
			? collapsed
				? `${PUBLIC_PREFIX_PATH}/logo-curto.png`
				: `${PUBLIC_PREFIX_PATH}/logo-comprido.png`
			: collapsed
				? `${PUBLIC_PREFIX_PATH}/logo-curto.png`
				: `${PUBLIC_PREFIX_PATH}/logo-comprido.png`;

	if (placement === "header") {
		return (
			<div
				className={`header-nav-logo ${collapsed ? "header-nav-logo--collapsed" : ""}`}
			>
				<img src={src} alt={APP_NAME} className="header-nav-logo__img" />
			</div>
		);
	}

	return (
		<div className={`side-nav-logo ${collapsed ? "side-nav-logo--collapsed" : ""}`}>
			<img src={src} alt={APP_NAME} className="side-nav-logo__img" />
		</div>
	);
};

export default SidebarLogo;
